;(function () {

"use strict";

var InputView = require('./input');
var SelectView = require('./select');
var TextAreaView = require('./text-area');
var MultipleFilesView = require('./multiple-files');
var CustomObjectView = require('./custom-object');
var CheckboxListView = require('./checkbox-list');
var SelectInputView = require('./select-input');
var DateInputView = require('./date-input');

var FormView = Backbone.View.extend({
  initialize: function (opts) {
    console.log('init form view');
    opts = opts || {};
    this.parent = opts.parent;
    this.initInputs();
  },
  initializeViews: function ($els, View) {
    var self = this;

    $els.each(function () {
      if ($(this).hasClass('skip')) { return true; }
      self.inputs.push(new View({el: this, parent: self}));
    });
  },
  initializeSelects: function () {
    var self = this;
    var $this;

    this.$el.find('select').each(function () {
      $this = $(this);

      if ($this.hasClass('skip')) { return true; }

      self.inputs.push(new SelectView({el: this, parent: self}));
    });
  },
  initializeSpecialViews: function () {
    this.$el.find('div.multiple-files-view').each(function () {
      new MultipleFilesView({el: this});
    });

    this.$el.find('div.custom-object-view').each(function () {
      new CustomObjectView({el: this});
    });

    this.$el.find('div.checkbox-list-view').each(function () {
      new CheckboxListView({el: this});
    });

    this.$el.find('div.select-input-view').each(function () {
      new SelectInputView({el: this});
    });

    this.$el.find('div.date-input-view').each(function () {
      new DateInputView({el: this});
    });
  },
  initInputs: function () {
    this.inputs = [];

    this.initializeSelects();
    this.initializeViews(this.$el.find('input'), InputView);
    this.initializeViews(this.$el.find('textarea'), TextAreaView);
    this.initializeSpecialViews();
  },
  onChange: function (view) {
    this.$el.addClass('edited');
    this.edited = true;
  },
  onBlur: function (view) {
    /* Empty for overriding */
  },
  onKeydown: function (view, e) {
    /* Empty for overriding */
  },
  onKeyup: function (view, e) {
    /* Empty for overriding */    
  },
  save: function (e) {

    if (e) {
      e.preventDefault();
    }

    this.$el.removeClass('edited');
    this.inputs.map(function (input) { if (input.reset) { input.reset(); } if (input.save) { input.save(); }});

    var valid = true;
    this.inputs.map(function (input) { input.validate(); if (!input.valid) { valid = false; }});
    this.valid = valid;
  },
  destroy: function () {    
    this.inputs.map(function (input) { input.destroy(); });

    this.undelegateEvents();
    $(this.el).removeData().unbind(); 
    this.remove();  
    Backbone.View.prototype.remove.call(this);
  },
  events: {
    'submit': 'save'
  }
});

module.exports = FormView;

}());